/* Aori — native predictive search for the header search drawer.
   Calls Shopify's /search/suggest.json (products + collections), renders an
   instant dropdown with brand/collection chips, product results, a "view all"
   link, and recent searches. No app required. */
(function () {
  'use strict';
  function boot() {
    var input = document.getElementById('HeaderSearchInput');
    var results = document.getElementById('HeaderSearchResults');
    if (!input || !results || input.dataset.psBound) return;
    input.dataset.psBound = '1';

    var DEBOUNCE = 200, MIN = 2, LIMIT = 8;
    var timer, controller, lastQ = '';

    var fmt = null;
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN';
      fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: cur });
    } catch (e) { /* noop */ }

    function money(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return '';
      if (fmt) { try { return fmt.format(n); } catch (e) {} }
      return '$' + n.toFixed(2);
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
    function thumb(url) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=96'; }
    function searchUrl(q) { return '/search?q=' + encodeURIComponent(q) + '&type=product'; }

    function getRecent() { try { return JSON.parse(localStorage.getItem('aori:recent') || '[]'); } catch (e) { return []; } }
    function pushRecent(q) {
      q = (q || '').trim(); if (!q) return;
      var r = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      r.unshift(q); r = r.slice(0, 5);
      try { localStorage.setItem('aori:recent', JSON.stringify(r)); } catch (e) {}
    }

    function renderRecent() {
      var r = getRecent();
      if (!r.length) { results.innerHTML = ''; return; }
      var html = '<div class="psr__section"><div class="psr__label">Búsquedas recientes</div><div class="psr__chips">';
      r.forEach(function (q) { html += '<a class="psr__chip" href="' + searchUrl(q) + '">' + esc(q) + '</a>'; });
      html += '</div></div>';
      results.innerHTML = html;
    }

    function render(q, data) {
      var res = (data && data.resources && data.resources.results) || {};
      var prods = res.products || [];
      var colls = res.collections || [];
      var html = '';
      if (colls.length) {
        html += '<div class="psr__section"><div class="psr__label">Marcas y colecciones</div><div class="psr__chips">';
        colls.slice(0, 6).forEach(function (c) { html += '<a class="psr__chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; });
        html += '</div></div>';
      }
      if (prods.length) {
        html += '<div class="psr__section"><div class="psr__label">Productos</div><ul class="psr__list">';
        prods.forEach(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var price = (p.price != null && p.price !== '') ? money(p.price) : '';
          html += '<li><a class="psr__item" href="' + esc(p.url) + '">'
            + (img ? '<img class="psr__thumb" src="' + esc(thumb(img)) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="psr__thumb psr__thumb--ph"></span>')
            + '<span class="psr__metacol"><span class="psr__title">' + esc(p.title) + '</span>'
            + (p.vendor ? '<span class="psr__vendor">' + esc(p.vendor) + '</span>' : '') + '</span>'
            + (price ? '<span class="psr__price">' + price + '</span>' : '')
            + '</a></li>';
        });
        html += '</ul></div>';
        html += '<a class="psr__all" href="' + searchUrl(q) + '">Ver todos los resultados para “' + esc(q) + '” →</a>';
      } else if (!colls.length) {
        html += '<div class="psr__empty">Sin resultados para “' + esc(q) + '”. <a href="' + searchUrl(q) + '">Buscar de todos modos →</a></div>';
      }
      results.innerHTML = html;
    }

    function fetchResults(q) {
      if (controller) { try { controller.abort(); } catch (e) {} }
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product,collection&resources[limit]=' + LIMIT
        + '&resources[options][unavailable_products]=last';
      results.classList.add('is-loading');
      fetch(url, { signal: controller && controller.signal, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { results.classList.remove('is-loading'); if (q === lastQ) render(q, data); })
        .catch(function (e) { if (e && e.name === 'AbortError') return; results.classList.remove('is-loading'); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim(); lastQ = q;
      clearTimeout(timer);
      if (q.length < MIN) { renderRecent(); return; }
      timer = setTimeout(function () { fetchResults(q); }, DEBOUNCE);
    });
    input.addEventListener('focus', function () { if (input.value.trim().length < MIN) renderRecent(); });

    var form = input.form;
    if (form) form.addEventListener('submit', function () { pushRecent(input.value); });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
